module.exports = __webpack_public_path__ + "static/media/tortitas.0670b31e.png";